module.exports = __webpack_public_path__ + "static/walk-this-way-a3dd39572c26e5a5bfb440c39c7e468d.jpg";